<template lang="pug">
  .profile-page.page
    .preloader-gif(
      v-if="isPending"
    )
    .container
      .profile-page__container
        .profile-page__side
          side-nav(
            v-bind:sideNavData="sideNavData"
          )
        router-view
    .page__footer
      main-footer
</template>
<script>
import {mapState} from "vuex";

import SideNav from "@/components/sideNav/SideNav";
import MainFooter from "@/components/footer/Footer";

export default {
  name: "OperatorPage",
  components: {
    SideNav,
    MainFooter
  },
  data() {
    return {
      isPending: false,
      sideNavData: {
        links: [
          {
            path: "/pages/operator/",
            second_path: "/pages/operator/requests/",
            text: "Заявки"
          },
          {
            path: "/pages/operator/shifts/",
            text: "Смены"
          },
          {
            path: "/pages/operator/camp/",
            text: "Лагерь"
          }
        ]
      }
    };
  },
  computed: {
    ...mapState(["userData"])
  },
  mounted() {
    // if (!this.userData || this.userData.role !== 4) {
    //   this.$router.push({ name: "Profile" });
    // }
    this.$root.$on("onShowPreloader", () => {
      this.isPending = true;
    });
    this.$root.$on("onHidePreloader", () => {
      this.isPending = false;
    });
  },
  beforeDestroy() {
    this.$root.$off("onShowPreloader");
    this.$root.$off("onHidePreloader");
  }
};
</script>
